import lms from '../../http/lms'

export default {
  namespaced: true,
  state: {
    professions: [],
    profession: null
  },
  mutations: {
    SET_PROFESSIONS(state, professions) {
      state.professions = professions
    },
    SET_PROFESSION(state, profession) {
      state.profession = profession.data || profession
    }
  },
  actions: {
    async fetchProfessions({ commit }) {
      try {
        const response = await lms.get('/professions')

        commit('SET_PROFESSIONS', response.data?.data || [])
      } catch (error) {
        console.error('Error fetching professions:', error)
      }
    },
    async getProfessionByID({ commit }, professionID) {
      try {
        const response = await lms.get(`/professions/${professionID}`)
        if (response && response.data && response.data.data) {
          response.data.data.professionPaths.forEach((path) => {
            let sum = 0

            path.pathCourses.forEach((course) => (sum += course.courseDuration))
            path.pathQuizzes.forEach((quiz) => {
              let quizDuration = sum * (10 / 100)
              quiz.quizDuration = quizDuration

              sum += quizDuration
            })

            path.pathDuration = sum
          })

          commit('SET_PROFESSION', response.data.data)
        } else {
          console.error('Empty or invalid response:', response)
        }
      } catch (error) {
        console.error('Error fetching profession:', error)
      }
    },
    async createProfession({}, profession) {
      try {
        const response = await lms.post('/professions', profession)
        return response
      } catch (error) {
        console.error('Error creating profession:', error)
      }
    },
    async updateProfession({}, profession) {
      try {
        const response = await lms.patch(`/professions/${profession.professionID}`, profession)
        return response
      } catch (error) {
        console.error('Error updating profession:', error)
      }
    },
    async deleteProfession({}, professionID) {
      try {
        const response = await lms.delete(`/professions/${professionID}`)
        return response
      } catch (error) {
        console.error('Error deleting profession:', error)
      }
    },
    async assessmentSubmission({}, assessment) {
      try {
        const response = await lms.post('/assessment-submission', assessment)
        return response
      } catch (error) {
        console.error('Error on assessmentSubmission:', error)
      }
    },
    async getSubmissionsFollow({}) {
      try {
        const response = await lms.get('/assessment-submission-follow')
        return response.data
      } catch (error) {
        console.error('Error on get assessmentSubmissionFollow:', error)
      }
    }
  },
  getters: {
    getProfessionById: (state) => (professionID) => {
      return state.professions.find((profession) => profession.professionID === professionID)
    },
    getProgession: (state) => {
      return state.profession
    },
    getProfessions: (state) => {
      return state.professions
    }
  }
}
